/**
 * Enum representing the possible frequency options for care elements
 */
export enum CareElementFrequencyType {
    None,
    ThreeMonths,
    SixMonths,
    Annual,
    Biennial
}
